__turbopack_context__.v({
  "default": "sanity-image-module-scss-module__NQvU4a__default",
  "fill": "sanity-image-module-scss-module__NQvU4a__fill",
  "img": "sanity-image-module-scss-module__NQvU4a__img",
});
